import { useSelector } from 'react-redux';

export const useIsAuthenticated = () => {
  const { user } = useSelector((state) => state.users);
  return !!user;
};
